module.exports = __webpack_public_path__ + "static/damian-sm-4deac62bde41701f78c176aaeac97604.jpg";